import React from "react";
import himg from "../../images/slider/as1.webp";
// import himg from "../../images/aslam/Asslam22.webp";
import { Link } from "react-scroll";
import "./style.css";

const Hero = () => {
  return (
    <section className="tp-hero-section-1">
      <div className="container">
        <div className="row">
          <div className="col col-xs-7 col-lg-7">
            <div className="tp-hero-section-text">
              <div className="tp-hero-title">
                <h2>
                  One Man. <br />
                  One Mission.
                </h2>
              </div>
              <div className="tp-hero-sub">
                <p>
                  To counsel One million students and empower 1000+ edupreneurs.
                </p>
              </div>
              <p className="hero-desc-text">
                For over 18 years, Asslam Shaikh has been helping students
                discover global opportunities beyond marks, money, and
                misconceptions. By guiding ambitious students toward
                international education and helping entrepreneurs build
                successful study abroad businesses, he is creating an ecosystem
                that transforms lives, careers, and communities.
              </p>
              <div className="hero-cta-btns">
                <Link
                  activeClass="active"
                  to="contact"
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={-95}
                  className="theme-btn"
                >
                  Connect with Asslam Shaikh
                </Link>
                <Link
                  activeClass="active"
                  to="contact"
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={-95}
                  className="theme-btn theme-btn-outline"
                >
                  Invite as Speaker
                </Link>
                {/* <Link
                  activeClass="active"
                  to="contact"
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={-95}
                  className="theme-btn"
                >
                  Partner With Us
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right-vec">
        <div className="right-img">
          <img src={himg} alt="" />
        </div>
      </div>
      <div className="social-link hidden">
        <ul>
          <li>
            <a
              href="https://www.facebook.com/AsslamIShaikh"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </li>
          <li>
            <a
              href="https://x.com/AsslamIShaikh"
              target="_blank"
              rel="noopener noreferrer"
            >
              X
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/asslamishaikh/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </li>
        </ul>
      </div>
      <div className="visible-text">
        <h1>Asslam</h1>
      </div>
    </section>
  );
};

export default Hero;
